import { useApplicationContext } from '../../utils/applicationContext';

import { IProgram, DomrfCalculator, IProps as IDomrfCalculatorProps } from '@cian/frontend-domrf-calculator';
import { MortgageContainer, MortgageContainerMobile } from '../MortgageContainer';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuilder, selectProject } from '../../selectors';
import { selectLocationId } from '../../selectors/location';
import { Section } from '../../components/Section';
import { isBuilderWithEscrow } from '../../utils/builder/isBuilderWithEscrow';
import { Responsive, useDeviceType } from '@cian/ui-kit';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { Microfrontend } from '@cian/mf-react';
import { MORTGAGE_MINI_CALCULATOR_MF_NAME } from '../../constants/microfrontends';
import { ContentContainer } from '../../components/ContentContainer';

type TTextData = Pick<
  IDomrfCalculatorProps,
  'title' | 'subtitle' | 'priceTooltipTitle' | 'priceTooltipText' | 'escrowTooltipText' | 'escrowTooltipTitle'
>;

const MORTGAGE_COMPONENTS = {
  desktop: MortgageContainer,
  tablet: MortgageContainerMobile,
  phone: MortgageContainerMobile,
};

export const MortgageCalculatorContainer = () => {
  const { config } = useApplicationContext();
  const regionId = useSelector(selectLocationId);
  const { startPrice, id: projectId } = useSelector(selectProject);
  const { id: builderId } = useSelector(selectBuilder);

  const domrfPrograms = config.get<IProgram[]>('audience.domrfMortgage.programs');
  const textData = config.get<TTextData>('audience.domrfMortgage.textData');

  const device = useDeviceType();

  const manifest = config.get<IMicrofrontendManifest>(`microfrontendManifests.${MORTGAGE_MINI_CALCULATOR_MF_NAME}`);

  // TODO: После того как будем удалять флаги, нужно будет переделать данный компонент, оставив только условие с манифестом
  // TODO: Удалить условие с domrfPrograms, т.к. оно не нужно будет https://jira.cian.tech/browse/CD-238691
  if (manifest) {
    const MicrofrontendComponent = (
      <Microfrontend name={manifest.microfrontendName} image={manifest.imageVersion} runtime={manifest.runtimeName} />
    );

    return (
      <Section>
        <Responsive desktop>{MicrofrontendComponent}</Responsive>
        <Responsive tablet phone>
          <ContentContainer>{MicrofrontendComponent}</ContentContainer>
        </Responsive>
      </Section>
    );
  }

  /* istanbul ignore else */
  if (!domrfPrograms) {
    const MortgageCalculatorComponent = MORTGAGE_COMPONENTS[device];

    return <MortgageCalculatorComponent />;
  }

  return (
    <Section>
      <DomrfCalculator
        programs={domrfPrograms}
        regionId={regionId}
        startPrice={startPrice}
        pageType="project"
        withEscrow={isBuilderWithEscrow(builderId, config)}
        objectId={projectId}
        {...textData}
      />
    </Section>
  );
};
